import React from "react";
import { Modal, Button } from "react-bootstrap";

const CommonConfirmModal = ({ show, onHide, title, message, onConfirm, confirmText }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="m-0">{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmText || "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonConfirmModal;
